export default "__VITE_ASSET__BBxMjii2__"